import { Routes } from '@angular/router'

import { DefaultApplicationPermissionsGuard } from '@flowx/designer/shared/guards/application-permissions.guards'
import {
  migrationConfigurationCanDeactivate,
  moveTokenConfigurationCanDeactivate,
} from '@flowx/designer/shared/guards/migration-configuration-can-deactivate.guard'
import { LayoutOptions } from '@flowx/designer/shared/types/layout.types'

export const CorrectiveActionsRoutes: Routes = [
  {
    path: '',
    data: { [LayoutOptions.HAS_SIDENAV]: true },
    loadComponent: () =>
      import('@flowx/designer/modules/projects/components/corrective-actions/list/corrective-actions-list.component').then(
        ({ CorrectiveActionsListComponent }) => CorrectiveActionsListComponent
      ),
    canActivate: [DefaultApplicationPermissionsGuard('process_instances_read')],
  },
  {
    path: 'migration/:migrationId/config',
    loadComponent: () =>
      import('@flowx/designer/modules/projects/components/corrective-actions/migration-configuration/migration-configuration.component').then(
        ({ MigrationConfigurationComponent }) => MigrationConfigurationComponent
      ),
    canDeactivate: [migrationConfigurationCanDeactivate],
    canActivate: [DefaultApplicationPermissionsGuard('process_instances_edit')],
  },
  {
    path: 'move-token/:moveTokenId/config',
    loadComponent: () =>
      import('@flowx/designer/modules/projects/components/corrective-actions/move-token-configuration/move-token-configuration.component').then(
        ({ MoveTokenConfigurationComponent }) => MoveTokenConfigurationComponent
      ),
    canDeactivate: [moveTokenConfigurationCanDeactivate],
    canActivate: [DefaultApplicationPermissionsGuard('process_instances_edit')],
  },
  {
    path: 'migration/:migrationId/details',
    loadComponent: () =>
      import('@flowx/designer/modules/projects/components/corrective-actions/migration-details/migration-details.component').then(
        ({ MigrationDetailsComponent }) => MigrationDetailsComponent
      ),
    canActivate: [DefaultApplicationPermissionsGuard('process_instances_read')],
  },
  {
    path: 'move-token/:moveTokenId/details',
    loadComponent: () =>
      import('@flowx/designer/modules/projects/components/corrective-actions/move-token-details/move-token-details.component').then(
        ({ MoveTokenDetailsComponent }) => MoveTokenDetailsComponent
      ),
    canActivate: [DefaultApplicationPermissionsGuard('process_instances_read')],
  },
]
